import React, { useEffect, useState } from 'react';
import { Button, Card, Typography, Grid, Box, Divider, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Modal, Paper, Chip, TextField } from '@mui/material';
import dayjs from 'dayjs';
import { BookingService } from '../Service';
import Swal from 'sweetalert2';
import { Add, ArrowBack, Check, Close, Delete, Edit, Remove } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import AddNewService from './AddNewService';
import { useForm, Controller } from 'react-hook-form';
import formatValue from '../../../utils/formatNumber';

export default function UpdateBooking(props) {
  const {control,watch,setValue} = useForm({
    defaultValues: {
      newPrice:null,
    }
  });
    const {id} = useParams();
    const navigate = useNavigate();
    const [bookingInProgressData, setBookingInProgressData] = useState({});
    const [addService, setAddService] = useState(false);

    const isServiceDateInPast = (serviceDate) => {
            const today = dayjs().startOf('day');
            const serviceDay = dayjs(serviceDate).startOf('day');
            return serviceDay.isBefore(today);
        }
    const fetchBookingDetails = async () => {
      Swal.fire({
        title: `Fetching Booking Details`,
        text: `${'Please wait while fetching booking details...' }`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
        const bookingDetails = await BookingService.bookingDetailById(id);
        if(bookingDetails.success == '1'){
          setBookingInProgressData(bookingDetails.data);
          if(bookingDetails?.data?.bookingStatus == 'completed' || bookingDetails?.data?.bookingStatus == 'cancelled' || bookingDetails?.data?.bookingStatus == 'rejected' && isServiceDateInPast(bookingDetails?.data?.serviceDate)){
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: `Booking is already ${bookingDetails?.data?.bookingStatus}. Please try again.`,
            })
            navigate(`/admin/booking-details/${id}`);
          }
          Swal.close();
        } else if(bookingDetails.success == '0'){
           Swal.fire({
          icon: 'error',
          title: 'Error',
          text: bookingDetails?.message || 'Something Went wrong. Please try again.',
        });
        console.error("Error in fetching booking details:", bookingDetails?.message);
        }
    }
    useEffect(()=>{
        if(id){
          fetchBookingDetails();
        }
    },[id])
    
    const handleQuantityChange = async (service, newQuantity) => {
      const requiredData = 
        {
          bookingId:id,
          providerId:bookingInProgressData?.providerId,
          customerId:bookingInProgressData?.customerId,
          services:[
            {
              id:service.id,
              providerServiceId:service?.providerServiceId,
              quantity:service?.quantity,
              newQuantity:newQuantity
            }
          ]
        }
      console.log("requiredData",requiredData);
      const isConfirm = await Swal.fire({
        title: 'Are you sure?',
        text: newQuantity == 0 ? `You are about to remove the service from the booking` : `You are about to change the quantity from ${service?.quantity} to ${newQuantity}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: newQuantity == 0 ? 'Yes, Remove it!' : 'Yes, Change it!',
        cancelButtonText: 'No, cancel!',
        allowOutsideClick: false,
      });
      if (isConfirm.isConfirmed) {
        // loading start
        Swal.fire({
          title: newQuantity == 0 ? `Service Remove` : `Quantity Change`,
          text: `${'Please wait while updating quantity...' }`,
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        // call api
        const quantityUpdateResponse = await BookingService.updateBookingServiceQuantity(requiredData);
        if (quantityUpdateResponse.success == "1") {
          const bookingDetails = await BookingService.bookingDetailById(id);
          setBookingInProgressData(bookingDetails.data);
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: newQuantity == 0 ? 'Service removed successfully.' : 'Quantity updated successfully.',
            showConfirmButton: false,
            timer: 1000
          });
        } else if (quantityUpdateResponse.success == "0") {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: quantityUpdateResponse?.message || 'Something Went wrong. Please try again.',
          });
        }
        // loading end
        
      }
    }
    const handleAddNewServices = async (services) => {

      const requiredData = 
        {
          bookingId:id,
          providerId:bookingInProgressData?.providerId,
          customerId:bookingInProgressData?.customerId,
          services:services
          // [
          //   // {
          //   //   id:service.id,
          //   //   providerServiceId:service?.providerServiceId,
          //   //   quantity:service?.quantity,
          //   //   newQuantity:newQuantity
          //   // }
          // ]
        }
      // console.log("requiredData",requiredData);
      // return;
      const isConfirm = await Swal.fire({
        title: 'Are you sure?',
        text: `You are about to add new services to the booking`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Add it!',
        cancelButtonText: 'No, cancel!',
        allowOutsideClick: false,
      });
      if (isConfirm.isConfirmed) {
        setAddService(false);
        // loading start
        Swal.fire({
          title: `New Services Addition`,
          text: `${'Please wait while adding new services...' }`,
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        // call api
        const quantityUpdateResponse = await BookingService.updateBookingServiceQuantity(requiredData);
        if (quantityUpdateResponse.success == "1") {
          const bookingDetails = await BookingService.bookingDetailById(id);
          setBookingInProgressData(bookingDetails.data);
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Services added successfully.',
            showConfirmButton: false,
            timer: 1000
          });
        } else if (quantityUpdateResponse.success == "0") {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: quantityUpdateResponse?.message || 'Something Went wrong. Please try again.',
          });
        }
        // loading end
        
      }
    }
    const handlePriceChange = async (service, newPrice) => {
      const requiredData = 
        {
          bookingId:id,
          providerId:bookingInProgressData?.providerId,
          customerId:bookingInProgressData?.customerId,
          services:[
            {
              id:service.id,
              providerServiceId:service?.providerServiceId,
              quantity:service?.quantity,
              newQuantity:service?.quantity,
              newPrice:newPrice
            }
          ]
        }
      console.log("requiredData",requiredData);
      const isConfirm = await Swal.fire({
        title: 'Are you sure?',
        text: newPrice == 0 ? `You are about to free the service` : `You are about to change the price from ${service?.price} to ${newPrice}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: newPrice == 0 ? 'Yes, Free it!' : 'Yes, Change it!',
        cancelButtonText: 'No, cancel!',
        allowOutsideClick: false,
      });
      if (isConfirm.isConfirmed) {
        // loading start
        Swal.fire({
          title: newPrice == 0 ? `Service Free` : `Price Change`,
          text: `${'Please wait while updating price...' }`,
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        // call api
        const quantityUpdateResponse = await BookingService.updateBookingServiceQuantity(requiredData);
        if (quantityUpdateResponse.success == "1") {
          const bookingDetails = await BookingService.bookingDetailById(id);
          setBookingInProgressData(bookingDetails.data);
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: newPrice == 0 ? 'Service freed successfully.' : 'Price updated successfully.',
            showConfirmButton: false,
            timer: 1000
          });
        } else if (quantityUpdateResponse.success == "0") {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: quantityUpdateResponse?.message || 'Something Went wrong. Please try again.',
          });
        }
        // loading end
        
      }
    }
    const [changeServicePrice, setChangeServicePrice] = useState(null);
  return (
    <>
      <PageHeaderLayout headerTitle={`Modify Booking`}>
        <Button size='small' variant='contained' onClick={() => navigate(-1)} endIcon={<ArrowBack sx={{fontSize:'.85rem!important'}}/>} sx={{height:'fit-content',fontSize:'x-small',p:'.5% 1.25%'}}>
            Back
        </Button>
      </PageHeaderLayout>
      <Box sx={{ overflow: "auto", backgroundColor: "#fff", padding: { xs: '2%', md: '1%' } }}>
        <Grid container spacing={2} >
          <Grid item xs={12} md={6} >
            <Box>
              <Typography sx={{ fontWeight: '600', color: '#494949', fontSize: { xs: '.85rem' } }}>Booking Details</Typography>
              <Card sx={{ p: '1%', bgcolor: '#dadada4d' }}>
                <Grid container spacing={{ xs: 0, md: 1 }}>
                  <Grid item xs={12} md={7}>
                    <Box sx={{ display: "flex" }}>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '60%', md: '40%' }, fontSize: '.75rem' }} variant='body1'>Booking Number </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '58%' }} >{bookingInProgressData?.bookingNumber || ''}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <Box sx={{ display: "flex" }}>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '20%' }, fontSize: '.75rem' }} variant='body1'>Status </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >
                        <Chip
                          label={bookingInProgressData?.bookingStatus}
                          size="small"
                          sx={{
                              // ml:1,
                              fontSize: '0.75rem',
                              fontWeight: '500',
                              color: bookingInProgressData?.bookingStatus === 'requested' ? '#E8832A' : bookingInProgressData?.bookingStatus === "rejected" ? '#F80000' : bookingInProgressData?.bookingStatus === 'completed' ? '#009EB4' : bookingInProgressData?.bookingStatus === 'accepted' ? '#40B962' : bookingInProgressData?.bookingStatus === 'cancelled' ? '#D81A23' : bookingInProgressData?.bookingStatus === 'ongoing' ? '#1A44B8' : 'default',
                              bgcolor: bookingInProgressData?.bookingStatus === 'requested' ? '#FFEDD5' : bookingInProgressData?.bookingStatus === "rejected" ? '#f800001f' : bookingInProgressData?.bookingStatus === 'completed' ? '#009eb442' : bookingInProgressData?.bookingStatus === 'accepted' ? '#40b96236' : bookingInProgressData?.bookingStatus === 'cancelled' ? '#d81a233b' : bookingInProgressData?.bookingStatus === 'ongoing' ? '#1a44b838' : 'default'
                          }}
                      />
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Card>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} >
            <Box>
              <Typography sx={{ fontWeight: '600', color: '#494949', fontSize: { xs: '.85rem' } }}>Schedule Details</Typography>
              <Card sx={{ p: '1%', bgcolor: '#dadada4d' }}>
                <Grid container spacing={{ xs: 0, md: 1 }}>
                  <Grid item xs={12} md={5}>
                    <Box sx={{ display: "flex" }}>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '30%' }, fontSize: '.75rem' }} variant='body1'>Date </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.serviceDate || ''}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <Box sx={{ display: "flex" }}>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '20%' }, fontSize: '.75rem' }} variant='body1'>Slot Timing </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >
                        {bookingInProgressData?.bookingStartTime && dayjs(bookingInProgressData?.bookingStartTime, 'HH:mm:ss').format('h:mm A')} -
                        {bookingInProgressData?.bookingEndTime && dayjs(bookingInProgressData?.bookingEndTime, 'HH:mm:ss').format('h:mm A')}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Card>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} >
            <Box>
              <Typography sx={{ fontWeight: '600', color: '#494949', fontSize: { xs: '.85rem' } }}>Customer Details</Typography>
              <Card sx={{ p: '1%', bgcolor: '#dadada4d' }}>
                <Grid container spacing={{ xs: 0, md: 1 }}>
                  <Grid item xs={12} md={5}>
                    <Box sx={{ display: "flex" }}>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '30%' }, fontSize: '.75rem' }} variant='body1'>Name </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.customerName}</Typography>
                    </Box>
                    <Box sx={{ display: "flex" }}>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '30%' }, fontSize: '.75rem' }} variant='body1'>Contact </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.customer?.mobileNumber || ''}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <Box sx={{ display: "flex" }}>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '20%' }, fontSize: '.75rem' }} variant='body1'>Address </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.customer?.defaultAddressDetail?.address || bookingInProgressData?.add_address}</Typography>
                    </Box>
                    <Box sx={{ display: "flex" }}>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '20%' }, fontSize: '.75rem' }} variant='body1'>Landmark </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.add_landmark || ''}</Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Card>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} >
            <Box>
              <Typography sx={{ fontWeight: '600', color: '#494949', fontSize: { xs: '.85rem' } }}>Service Expert</Typography>
              <Card sx={{ p: '1%', bgcolor: '#dadada4d' }}>
                <Grid container spacing={{ xs: 0, md: 1 }}>
                  <Grid item xs={12} md={5}>
                    <Box sx={{ display: "flex" }}>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '30%' }, fontSize: '.75rem' }} variant='body1'>Name </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.providerName}</Typography>
                    </Box>
                    <Box sx={{ display: "flex" }}>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '30%' }, fontSize: '.75rem' }} variant='body1'>Contact </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.provider?.mobileNumber || ''}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <Box sx={{ display: "flex" }}>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '20%' }, fontSize: '.75rem' }} variant='body1'>Address </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                      <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.provider?.UserAddress?.address}</Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Card>
            </Box>
          </Grid>
          
          <Grid item xs={12} >
            <Box>
              <Typography sx={{ fontWeight: '600', color: '#494949', fontSize: { xs: '.85rem' } }}>Service Details</Typography>
              <Card sx={{ bgcolor: '#dadada4d' }}>
                <Grid container>
                  <Grid item xs={12} md={9}>
                    <Box>
                      <TableContainer>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 600, color: '#6E6E6E', p: '1%', fontSize: '.75rem' }} width="40%" >Service</TableCell>
                              <TableCell sx={{ fontWeight: 600, color: '#6E6E6E', p: '1%', fontSize: '.75rem' }} width="15%" >Quantity</TableCell>
                              <TableCell sx={{ fontWeight: 600, color: '#6E6E6E', p: '1%', fontSize: '.75rem' }} width="15%" >Time</TableCell>
                              <TableCell sx={{ fontWeight: 600, color: '#6E6E6E', p: '1%', fontSize: '.75rem' }} width="15%" >Price</TableCell>
                              <TableCell sx={{ fontWeight: 600, color: '#6E6E6E', p: '1%', fontSize: '.75rem' }} width="15%" >Total </TableCell>
                              <TableCell sx={{ fontWeight: 600, color: '#6E6E6E', p: '1%', fontSize: '.75rem' }} width="15%" > </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {bookingInProgressData?.bookingItems &&  bookingInProgressData?.bookingItems.length>0 &&bookingInProgressData?.bookingItems.map((service) => (
                              <TableRow key={service?.id} sx={{ borderBottom: 'none' }}>
                                <TableCell sx={{ p: '.5% 1%', color: '#494949', borderBottom: 'none', fontSize: '0.75rem' }}>{service?.serviceName}{service?.providerServices?.brd.id != '1' && <Box component={'span'} sx={{color:'#1976d2'}}>{`_${service?.providerServices?.brd.title}`}</Box>}</TableCell>
                                <TableCell sx={{ p: '.5% 1%', color: '#494949', borderBottom: 'none', fontSize: '0.75rem' }}>
                                  {/* {service?.quantity} */}
                                  <Paper sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                      <IconButton
                                          size="small"
                                          onClick={() => handleQuantityChange(service, Math.max(0, service.quantity - 1))}
                                      >
                                          <Remove sx={{ color: '#1A44B8' }} fontSize='small' />
                                      </IconButton>
                                      <Box sx={{ borderLeft: '1px solid #ccc', borderRight: '1px solid #ccc', padding: '.25rem .5rem' }}>
                                          <Typography>
                                              {service.quantity}
                                          </Typography>
                                      </Box>

                                      <IconButton
                                          size="small"
                                          onClick={() => handleQuantityChange(service, service.quantity + 1)}
                                      >
                                          <Add fontSize='small' sx={{ color: '#1A44B8' }} />
                                      </IconButton>
                                  </Paper>
                                </TableCell>
                                <TableCell sx={{ p: '.5% 1%', color: '#494949', borderBottom: 'none', fontSize: '0.75rem' }}>{service?.serviceTime}mins</TableCell>
                                <TableCell sx={{ p: '.5% 1%', color: '#494949', borderBottom: 'none', fontSize: '0.75rem',minWidth:'15rem'}} >
                                 <Box sx={{display:'flex',alignItems:'center',justifyContent:'center' ,width:'100%'}}>
                                  {
                                    changeServicePrice === service?.id ? 
                                    <Paper sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                      <Controller
                                        name="newPrice"
                                        control={control}
                                        rules={{
                                            required: 'Price is required',
                                            validate: (value) => {
                                                const floatValue = parseFloat(value);
                                                if (isNaN(floatValue)) return 'Please enter a valid number';
                                                if (floatValue > 0 && floatValue < 1) return 'Price should not be less than ₹1';
                                                return floatValue > 0 || 'Price should not be negative';
                                            }
                                        }}
                                        defaultValue={0}
                                        render={({ field, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                type="number"
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    let finalValue;
                                                    if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
                                                    
                                                    finalValue = formatValue(inputValue);
                                                    console.log("finalValue",finalValue)

                                                    if(finalValue==''){
                                                        finalValue=0
                                                    }
                                                        field.onChange(finalValue);
                                                    }
                                                }}
                                                inputMode="decimal"
                                                size="small"
                                                inputProps={{
                                                    style: { textAlign: 'center',  height: '1rem' },
                                                    min: 0,
                                                    step: 0.01, // Allow two decimal places
                                                    onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                                    onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused 
                                                    onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                                    onKeyDown: (e) => {
                                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                            e.preventDefault();
                                                        }
                                                    }
                                                }}
                                                error={!!error}
                                            />
                                        )}
                                    />
                                    </Paper>
                                    :
                                    service?.price
                                  }
                                  {
                                    changeServicePrice === service?.id ?
                                    <>
                                    <IconButton size='small' color='success' onClick={() => {
                                      setChangeServicePrice(null);
                                      handlePriceChange(service, watch('newPrice'));
                                    }}>
                                      <Check fontSize='small' />
                                    </IconButton>
                                    <IconButton size='small' color='error' onClick={() => {
                                      setChangeServicePrice(null);
                                      setValue('newPrice',null);
                                    }}>
                                      <Close fontSize='small' />
                                    </IconButton>
                                    </>
                                    :
                                    <IconButton color='warning' size='small' sx={{ml:1}} onClick={() => {
                                      setChangeServicePrice(service?.id)
                                      setValue('newPrice',service?.price);
                                    }}>
                                    <Edit sx={{ fontSize:"1rem"}}  />
                                  </IconButton>
                                  }
                                  </Box>
                                </TableCell>
                                <TableCell sx={{ p: '.5% 1%', color: '#494949', borderBottom: 'none', fontSize: '0.75rem' }}>{parseFloat(service?.price * service?.quantity).toFixed(2)}</TableCell>
                                <TableCell sx={{ p: '.5% 1%', color: '#494949', borderBottom: 'none', fontSize: '0.75rem',px:1 }}>
                                  { (bookingInProgressData?.bookingItems &&  bookingInProgressData?.bookingItems.length>1) &&
                                    <IconButton size='small' color='error' onClick={() => handleQuantityChange(service, 0)}>
                                      <Delete fontSize='small' />
                                    </IconButton>
                                  }
                                </TableCell>
                              </TableRow>
                            ))}
                            <TableRow>
                                <TableCell sx={{ p: '.5% 1%', color: '#494949', borderBottom: 'none', fontSize: '0.75rem' }}>
                                  <Button variant='contained' size='small' onClick={()=>setAddService(true)}>
                              Add New Service
                            </Button>
                                </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={3} sx={{ borderTop: { md: 'none', xs: '1px solid #BEC2C2' }, borderLeft: { sm: 'none', md: '1px solid #BEC2C2' }, display: { sm: 'flex', md: 'block' }, justifyContent: 'end', pr: { sm: '5%', md: '0%' } }}>
                    <Box sx={{ p: '4%', borderBottom: '1px solid #BEC2C2', display: { sm: 'none', md: 'block' } }}>
                      <Typography sx={{ fontWeight: 600, fontSize: '0.75rem' }}>Payment Summary</Typography>
                    </Box>
                    <Box sx={{ minWidth: { xs: '14rem', md: '0rem' } }}>
                      <Box sx={{ px: 1, display: 'flex', justifyContent: 'space-between', mb: .5 }}>
                        <Typography sx={{ fontSize: '0.75rem' }} color="text.secondary">
                          Subtotal
                        </Typography>
                        <Typography sx={{ fontSize: '0.75rem' }}>
                          ₹ {bookingInProgressData?.subTotal &&parseFloat(bookingInProgressData?.subTotal).toFixed(2)}
                        </Typography>
                      </Box>
                      <Box sx={{ px: 1, display: 'flex', justifyContent: 'space-between', mb: .5 }}>
                        <Typography sx={{ fontSize: '0.75rem' }} color="text.secondary">
                          Platform Fee
                        </Typography>
                        <Typography sx={{ fontSize: '0.75rem' }}>
                          ₹ {bookingInProgressData?.platformCharges && parseFloat(bookingInProgressData?.platformCharges).toFixed(2)}
                        </Typography>
                      </Box>
                      <Box sx={{ px: 1, display: 'flex', justifyContent: 'space-between', mb: .5 }}>
                        <Typography sx={{ fontSize: '0.75rem' }} color="text.secondary">
                          Convenience Fee
                        </Typography>
                        <Typography sx={{ fontSize: '0.75rem' }}>
                          ₹ {bookingInProgressData?.convenienceFee && parseFloat(bookingInProgressData?.convenienceFee).toFixed(2)}
                        </Typography>
                      </Box>
                      <Box sx={{ px: 1, display: 'flex', justifyContent: 'space-between', mb: .5 }}>
                        <Typography sx={{ fontSize: '0.75rem' }} color="text.secondary">
                          Discount
                        </Typography>
                        <Box>
                          <Typography sx={{ fontSize: '0.75rem', color: '#d32f2f',textAlign:'right' }}>
                            ₹ {bookingInProgressData?.couponAmount && parseFloat(bookingInProgressData?.couponAmount).toFixed(2)}
                          </Typography>
                          {bookingInProgressData?.couponDetails && <Box sx={{}}>
                            <Box sx={{display:'flex',alignItems:'center',justifyContent:'end'}}>
                            <Typography sx={{fontSize: '0.55rem',border:'1px dashed red',p:'.6% 2%',fontWeight:600,bgcolor:'#3a2bde',color:'#fff'}}>
                                {bookingInProgressData?.couponDetails.couponCode}
                            </Typography>
                            {/* <IconButton sx={{p:0}} size='small' color='error' onClick={()=>removeCoupon()}><Close sx={{fontSize:'1rem'}}/></IconButton> */}
                            </Box>
                          </Box>}
                        </Box>
                      </Box>
                      <Box sx={{ px: 1, display: bookingInProgressData?.coinValue > 0 ? 'flex' : 'none', justifyContent: 'space-between', mb: .5 }}>
                        <Typography sx={{ fontSize: '0.75rem' }} color="text.secondary">
                          Cudel Coins Used
                        </Typography>
                        <Typography sx={{ fontSize: '0.75rem', color: '#d32f2f' }}>
                          ₹  {bookingInProgressData?.coinValue && parseFloat(bookingInProgressData?.coinValue).toFixed(2)}

                        </Typography>
                      </Box>
                      <Box sx={{ px: 1, display: 'flex', justifyContent: 'space-between', mb: .5 }}>
                        <Typography sx={{ fontSize: '0.75rem' }} color="text.secondary">
                          Visiting Charge
                        </Typography>
                        <Typography sx={{ fontSize: '0.75rem' }}>
                          ₹ {bookingInProgressData?.visitingCharge && parseFloat(bookingInProgressData?.visitingCharge).toFixed(2)}
                        </Typography>
                      </Box>
                      <Box sx={{ px: 1, display: 'flex', justifyContent: 'space-between', mb: .5 }}>
                        <Typography sx={{ fontSize: '0.75rem' }} color="text.secondary">
                          Tax
                        </Typography>
                        <Typography sx={{ fontSize: '0.75rem' }}>
                          ₹ {bookingInProgressData?.tax && parseFloat(bookingInProgressData?.tax).toFixed(2)}
                        </Typography>
                      </Box>



                      <Divider sx={{ my: .5 }} />

                      <Box sx={{ p: 1, display: 'flex', justifyContent: 'space-between' }}>
                        <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#3e3e3e' }}>
                          Total Amount
                        </Typography>
                        <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#3e3e3e' }}>

                          ₹ {bookingInProgressData?.total && parseFloat(bookingInProgressData?.total).toFixed(2)}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Card>
            </Box>
          </Grid>
        </Grid>
        {/* Add New Service Modal */}
        <Modal
          open={addService}
          // onClose={() => setOpenServiceDropdown(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ overflow: "scroll" }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: { xs: '50%', sm: '50%' },
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'background.paper',
              p: 0,
              width: { xs: "95%", sm: "75%" },
              minHeight: '25%'
            }}

            borderRadius={2}
          >
            <Box sx={{ borderBottom: '1px solid lightGray', display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '1% 2%' }}>
              <Typography sx={{ fontWeight: 600, fontSize: '.9rem' }} >
                Add New Service
              </Typography>
              <IconButton
                size='small'
                onClick={() => setAddService(false)}
                sx={{ p: 0 }}
                color='error'
              >
                <Close sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }} />
              </IconButton>
            </Box>
            <Box sx={{ p: '2%' }}>
              <AddNewService  providerId={bookingInProgressData?.providerId} bookingItems = {bookingInProgressData?.bookingItems} handleAddNewServices={handleAddNewServices}/>
            </Box>
          </Box>
        </Modal>
      </Box >
    </>
  );
}
